<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='日志查询'></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 80px;text-align:right;">日志类型：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.logclass" disabled>
                  <el-option label="业务日志" value="business"></el-option>
                  <el-option label="系统日志" value="system"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 80px;text-align:right;">操作类型：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.logtype">
                  <el-option label="请选择" value=""></el-option>
                  <el-option label="新增" value="Add"></el-option>
                  <el-option label="修改" value="Update"></el-option>
                  <el-option label="删除" value="Del"></el-option>
                  <el-option label="审核" value="Check"></el-option>
                  <el-option label="启用" value="Enable"></el-option>
                  <el-option label="停用" value="Disable"></el-option>
                  <el-option label="其它" value="Other"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 80px;text-align:right;">数据类型：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.datatype">
                  <el-option label="汇总数据" value="total"></el-option>
                  <el-option label="实时数据" value="actual"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 80px;text-align:right;">日志时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.logdate" type="daterange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期"></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url="searchUrl" ref="btnSearch"></SearchButton>
        </div>
        <!--end: Search Form -->
      </div>
      <div class="m-portlet__body">
        <!--begin: Datatable -->
        <el-table :data="tableData" stripe style="width: 100%" size="medium">
          <el-table-column prop="LogDate" :formatter="this.$utils.dateFormat" label="操作日期" width="180px">
          </el-table-column>
          <el-table-column prop="LogType" :formatter="this.actionFormat" label="操作类型" width="80px">
          </el-table-column>
          <el-table-column prop="LogUserName" width="100px" label="操作人">
          </el-table-column>
          <el-table-column prop="LogTitle" label="日志标题">
          </el-table-column>
          <el-table-column prop="LogInfo" show-overflow-tooltip label="日志内容">
          </el-table-column>
          <!-- <el-table-column prop="OldData" label="旧数据">
          </el-table-column>
          <el-table-column prop="NewData" label="新数据">
          </el-table-column> -->
          <el-table-column prop="LogStatus" label="执行状态" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.LogStatus === 0" style="color:#F56C6C">失败</span>
              <span v-else style="color: #67C23A">成功</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="LogRemark" label="备注">
          </el-table-column> -->
        </el-table>
        <!--end: Datatable -->
        <!--begin: Pager -->
        <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="condition.recordCount">
          </el-pagination>
        </div>
        <!--end: Pager -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LogList',
    data() {
      return {
        condition: {
          logclass: 'business',
          logdate: '',
          datatype: 'total',
          logtype: '',
          token: '',
          currentPage: 1,
          pageSize: 10,
          recordCount: 0,
          firstSearch: true
        },
        tableData: null,
        searchUrl: this.$utils.Url.system + '/systemapi/log/list'
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      actionFormat: function(row, column) {
        var action = row[column.property]
        if (action === 'Add') {
          return '新增'
        } else if (action === 'Del') {
          return '删除'
        } else if (action === 'Update') {
          return '更新'
        } else if (action === 'Check') {
          return '审核'
        } else if (action === 'Enable') {
          return '启用'
        } else if (action === 'Disable') {
          return '停用'
        } else if (action === 'Other') {
          return '其它'
        } else {
          return ''
        }
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style>
</style>
